import { createEffect, createSignal, onCleanup, onMount, type Signal } from 'solid-js'

export default function createMountedInverval(
  fn: () => void,
  time: number | undefined
): Signal<boolean> {
  let interval: NodeJS.Timeout
  // eslint-disable-next-line solid/reactivity
  const signal = createSignal(false)
  const [isActive, setIsActive] = signal
  onMount(() => {
    setIsActive(true)
  })
  onCleanup(() => {
    setIsActive(false)
    clearInterval(interval)
  })

  createEffect(() => {
    if (isActive()) {
      interval = setInterval(fn, time)
    } else {
      clearInterval(interval)
    }
  })

  return signal
}
